import { render } from "./DeviceBulkUpload.vue?vue&type=template&id=21ff1984"
import script from "./DeviceBulkUpload.vue?vue&type=script&lang=js"
export * from "./DeviceBulkUpload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__